<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="115 95 335 210">
    <path
      class="st0"
      fill="#c74634"
      d="M221.4,300c-55.6,0-100-44.4-100-100s44.4-100,100-100h117.2c55.6,0,100,44.4,100,100s-44.4,100-100,100H221.4z
	 M335.6,264.6c36.4,0,64.6-29.3,64.6-64.6c0-36.4-29.3-64.6-64.6-64.6H224.4c-36.4,0-64.6,29.3-64.6,64.6s29.3,64.6,64.6,64.6H335.6
	z" />
  </svg>
</template>
<script setup lang="ts">
defineOptions({
  name: 'mark-product-oracle'
})
</script>
